import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const PrivateRoutes = ({ isUserLoggedIn, useAuth }) => {
    return isUserLoggedIn ? <Outlet /> : <Navigate to="/login" />;
};
